export enum PrinterType {
  F23 = 4,
  p55 = 5,
  p95 = 1,
  p55s = 8,
  p95s = 7,
  mr = 3,
  Other = 6,
}
